import React, { useContext } from "react";
import MainLayout from "../../_layout/MainLayout";
import useSavedContacts from "./useSavedContacts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDeleteLeft, faEdit } from "@fortawesome/free-solid-svg-icons";
import { Spin } from "antd";
import ContactModal from "../../_component/ContactModal";
import ContactDeleteModal from "../../_component/ContactDeleteModal";
import { AuthContext } from "../../_hooks/useAuthContext";
function SavedContacts(props) {
  const {
    user,
    loading,
    allContacts,
    contactModalOpen,
    deleteContact,
    deleteModalOpen,
    exportUserIds,

    onContactDelete,
    handleContactModalOpen,
    selectedContactId,
    handleDeleteModalOpen,
    handleLoginClick,
  } = useSavedContacts(props);

  const { authenticated } = useContext(AuthContext);

  return (
    <MainLayout activeMenuItem="home">
      <div className="p-4 sticky">
        <div className="flex mb-4 window-container">
          <h2 className="window-title mr-auto">Saved Contacts</h2>
          <div className="flex justify-end">
            {authenticated ? (
              <button
                className="btn bg-slate-50 text-gray-900 rounded-xl outline outline-1 hover:bg-slate-200"
                onClick={() => handleContactModalOpen({})}
              >
                Add Contact
              </button>
            ) : (
              <button
                className="btn bg-slate-50 text-gray-900 rounded-xl outline outline-1 hover:bg-slate-200"
                onClick={() => handleLoginClick()}
              >
                Login
              </button>
            )}
          </div>
        </div>

        {loading ? (
          <div className="centered spinner-box">
            <Spin size="large" />
          </div>
        ) : (
          <div className="centered min-h-[90vh] flex-col gap-2 w-full">
            <div className="overflow-x-auto w-full flex-col mb-8">
              {authenticated ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {Array.isArray(allContacts) && allContacts.length > 0 ? (
                    allContacts.map((item, index) => (
                      <div 
                        key={item._id || index} 
                        className="bg-white rounded-lg shadow-md p-4 border border-gray-200 hover:shadow-lg transition-shadow"
                      >
                        <div className="flex justify-between items-start mb-3">
                          <h3 className="text-lg font-medium text-blue-900">{item?.name}</h3>
                          <div className="flex space-x-2">
                            <FontAwesomeIcon
                              className="cursor-pointer text-blue-500 hover:text-blue-700"
                              icon={faEdit}
                              onClick={() => handleContactModalOpen(item)}
                            />
                            <FontAwesomeIcon
                              className="cursor-pointer text-red-500 hover:text-red-700"
                              icon={faDeleteLeft}
                              onClick={() => onContactDelete(item)}
                            />
                          </div>
                        </div>
                        
                        <div className="space-y-2 text-sm">
                          <div className="flex items-start">
                            <span className="font-medium text-gray-500 w-24 flex-shrink-0">Email:</span>
                            <a 
                              href={`mailto:${item?.email}`}
                              className="text-blue-700 hover:text-blue-800 hover:underline break-words max-w-full inline-block truncate"
                              title={item?.email}
                            >
                              {item?.email?.length > 25 ? `${item?.email.substring(0, 25)}...` : item?.email}
                            </a>
                          </div>
                          
                          <div className="flex items-center">
                            <span className="font-medium text-gray-500 w-24">Phone:</span>
                            <a 
                              href={`tel:${item?.contact_number}`}
                              className="text-blue-700 hover:text-blue-800 hover:underline"
                            >
                              {item?.contact_number}
                            </a>
                          </div>
                          
                          <div className="flex items-center">
                            <span className="font-medium text-gray-500 w-24">Company:</span>
                            <span className="text-gray-600">{item?.company_id?.name}</span>
                          </div>
                          
                          <div className="flex items-center">
                            <span className="font-medium text-gray-500 w-24">Category:</span>
                            <span className="text-gray-600">
                              {item?.category_ids
                                ?.map((category) => category.title)
                                .join(", ")}
                            </span>
                          </div>
                          
                          <div className="flex items-center">
                            <span className="font-medium text-gray-500 w-24">Job Title:</span>
                            <span className="text-gray-600">{item?.job_title}</span>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="col-span-full text-center py-8 text-gray-500">
                      No contacts found. Add a contact to get started.
                    </div>
                  )}
                </div>
              ) : (
                <p className="p-2">Login to continue</p>
              )}
            </div>
          </div>
        )}

        {/* Contact Modal */}
        <ContactModal
          contactModalOpen={contactModalOpen}
          handleContactModalOpen={handleContactModalOpen}
          contactId={selectedContactId}
        />

        {/* Delete Modal */}
        <ContactDeleteModal
          deleteContact={deleteContact}
          deleteModalOpen={deleteModalOpen}
          handleDeleteModalOpen={handleDeleteModalOpen}
        />
      </div>
    </MainLayout>
  );
}

export default SavedContacts;
